import * as angular from 'angular';

// reCAPTCHA v2 ("I'm not a robot" checkbox) site key (public). The secret key lives only on the server, in db/hubspot-submit.php
export const RECAPTCHA_SITE_KEY = '6LensPgtAAAAAAjyWvDkQbmkyh69p6SKVqs6542c';

export class FiRecaptchaService {

    static $inject = [
        '$q',
        '$window',
    ];

    constructor(
        private $q: angular.IQService,
        private $window: angular.IWindowService,
    ) {
    }

    private loaded: angular.IPromise<any>;

    load() {
        if (!this.loaded) {
            const deferred = this.$q.defer();
            const script = document.createElement('script');

            this.$window['fiRecaptchaLoaded'] = () => deferred.resolve(this.$window['grecaptcha']);
            script.src = 'https://www.google.com/recaptcha/api.js?render=explicit&hl=lt&onload=fiRecaptchaLoaded';
            script.onerror = () => {
                this.loaded = null;
                deferred.reject('reCAPTCHA script failed to load');
            };

            document.head.appendChild(script);
            this.loaded = deferred.promise;
        }

        return this.loaded;
    }

    // onToken gets the token once the box is ticked. onExpired is called when the token expires (after 2 minutes)
    // or the widget fails - the box then has to be ticked again
    render(element: Element, onToken: (token: string) => void, onExpired: () => void): angular.IPromise<number> {
        return this.load().then((grecaptcha) => grecaptcha.render(element, {
            'sitekey': RECAPTCHA_SITE_KEY,
            'callback': onToken,
            'expired-callback': onExpired,
            'error-callback': onExpired,
        }));
    }
}
